// Meldung des Servers, wenn placeOrder eine Adresse ablehnt; der Kontaktschritt zeigt sie an.
// reference: [DynamicOrderController 3]
export const addressRejection = $state({message: ''});
